export default {
  base_url: window.location.hostname === '192.168.1.101' ? '/off' : '/api',
  // 试用账号
  // 试用账号密码
  // 登录页 通知公告4.0
  notice_content: "",
};
